import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils';

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ProductLedgerPdf = ({ data }) => {
  console.log('ProductLedgerPdf Data:', data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Product Ledger Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            {data.map((group, groupIndex) => (
              <View key={groupIndex} style={{ marginBottom: 20 }}>
                <Text
                  style={{ fontSize: '9px', marginBottom: 2 ,marginTop:"2%"}}
                  content={`Product: ${group.productInfo?.main?.name || 'N/A'}`}
                />
                <View style={{ ...styles.row, borderBottomWidth: 1 }}>
                  <Text style={styles.columnHeader} content="Sr" />
                  <Text style={styles.columnHeader} content="Doc No" />
                  <Text style={styles.columnHeader} content="Doc Date" />
                  <Text style={styles.columnHeader} content="Type" />
                  <Text style={styles.columnHeader} content="In Qty" />
                  <Text style={styles.columnHeader} content="Out Qty" />
                  <Text style={styles.columnHeader} content="Batch No" />
                  <Text style={styles.columnHeader} content="Expiry Date" />
                  <Text style={styles.columnHeader} content="Rate" />
                  <Text style={styles.columnHeader} content="Amount" />
                </View>
                {group.transactions.map((txn, txnIndex) => (
                  <View key={txnIndex} style={{ ...styles.row, backgroundColor: COLORS[txnIndex % COLORS.length] }}>
                    <Text style={styles.columnContent} content={txnIndex + 1} />
                    <Text style={styles.columnContent} content={txn.doc_no || 'N/A'} />
                    <Text style={styles.columnContent} content={formatDate(txn.date) || 'N/A'} />
                    <Text style={styles.columnContent} content={(txn.type) || 'N/A'} />
                    <Text style={styles.columnContent} content={txn.inQty || 0} />
                    <Text style={styles.columnContent} content={txn.outQty || 0} />
                    <Text style={styles.columnContent} content={txn.batch_no || 'N/A'} />
                    <Text style={styles.columnContent} content={formatDate(txn.exp_date)} />
                    <Text style={styles.columnContent} content={txn.purRate || txn.saleRate || 0} />
                    <Text style={styles.columnContent} content={txn.purAmount || txn.saleAmount || 0} />
                  </View>
                ))}
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default ProductLedgerPdf;
